<ng-container *ngIf="isMobile else desktopTemplate">
	<div class="mobile-kamona-container">
		<div class="mobile-kamona-header">
			<div class="business-information-mobile-wrapper">
				<div nz-row nzAlign="middle" nzJustify="space-between">
					<div>
						<app-back-navigation-button
							(goBack)="goBack()"
							[buttonName]="currentStep.previousTitle">
						</app-back-navigation-button>
					</div>
					<div>
						<div>
							<app-time-line-progress
								[currentStep]="currentStep?.step"
								[totalStep]="TOTAL_STEP">
							</app-time-line-progress>
						</div>
					</div>
				</div>
				<div class="m-t-8">
					<app-time-line-details
						[description]="currentStep?.description"
						[title]="currentStep?.title">
					</app-time-line-details>
				</div>
			</div>
		</div>
		<div class="mobile-kamona-content">
			<div class="mobile-kamona-inner-content">
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
</ng-container>
<ng-template #desktopTemplate>
	<div>
		<div class="business-pin-desktop">
			<div class="desktop-card">
				<div class="top-content">
					<div [nzGutter]="19" nz-row nzJustify="space-between">
						<div nz-col nzSpan="20">
							<app-time-line-details
								[description]="currentStep?.description"
								[title]="currentStep?.title">
							</app-time-line-details>
						</div>
						<div nz-col nzSpan="4">
							<app-time-line-progress
								[currentStep]="currentStep?.step"
								[totalStep]="TOTAL_STEP">
							</app-time-line-progress>
						</div>
					</div>
					<router-outlet></router-outlet>
				</div>
			</div>
		</div>
	</div>
</ng-template>

